<template>
    <a-modal 
             :visible="isVisible"
             :closable="false"
             width="400px"
    >
        <template slot="footer">
            <a-button key="back" @click="handleCancel">
                Close
            </a-button>
        </template>
        <a-row type="flex" justify="start" class="icons-list">

            <a-popconfirm placement="top" ok-text="Yes" cancel-text="No" @confirm="handleReady" v-show="buttonEnabled.setReady">
                <template slot="title">
                    <p>Is the order ready?</p>
                </template>
                <a-button icon="down-square" block shape="round">
                    Set Ready
                </a-button>
            </a-popconfirm>

            <a-popconfirm placement="top" ok-text="Yes" cancel-text="No" @confirm="handleDelivered" v-show="buttonEnabled.setDelivered">
                <template slot="title">
                    <p>Is the order delivered?</p>
                </template>
                <a-button icon="check" block shape="round">
                    Set Delivered
                </a-button>
            </a-popconfirm>

            <a-popconfirm placement="top" ok-text="Yes" cancel-text="No" @confirm="handlePendingToInprogress" v-show="buttonEnabled.setInprogress">
                <template slot="title">
                    <p>Is the order ready?</p>
                </template>
                <a-button icon="down-square" block shape="round">
                    Set Inprogress
                </a-button>
            </a-popconfirm>
        
            <a-button icon="clock-circle" block shape="round" @click="handleChangePickupTime" v-show="buttonEnabled.changePickupTime">
                Change pickup time
            </a-button>
            
            <a-button icon="clock-circle" block shape="round" @click="handleChangePriorityOrASAP" v-show="buttonEnabled.setAsap">
                Change Priority/ASAP
            </a-button>

            <a-button icon="clock-circle" block shape="round" @click="handleViewOrder">
                View
            </a-button>

            <a-popconfirm placement="top" ok-text="Yes" cancel-text="No" @confirm="handlePrint" v-show="buttonEnabled.print">
                <template slot="title">
                    <p>Print order?</p>
                </template>
                <a-button icon="printer" block shape="round">
                    Print
                </a-button>
            </a-popconfirm>

            <a-button icon="clock-circle" block shape="round" @click="handleChangePickupDate" v-show="buttonEnabled.changePickupDate">
                Change pickup date
            </a-button>
            
            <a-popconfirm placement="top" ok-text="Yes" cancel-text="No" @confirm="handleCancelOrder" v-show="buttonEnabled.cancelOrder">
                <template slot="title">
                    <p>Cancel order?</p>
                </template>
                <a-button icon="close" block shape="round">
                    Cancel
                </a-button>
            </a-popconfirm>
        </a-row>
    </a-modal>
</template>

<script>
export default {

    data() {
        return {
            isVisible : false,
            buttonEnabled : {
                setReady : true,
                setInprogress : true,
                setDelivered : true,
                changePickupTime : true,
                changePickupDate : true,
                setAsap : true,
                print : true,
                cancelOrder : true,
                makePayment : true,
                
            }
            
        }
    },
    methods : {
        
        show(record) {

            //console.log(this.buttonEnabled)
            this.isVisible = true;  
            
            //
            //Set buttons
            //
            if(record.state == 0) { //Pending
                this.buttonEnabled.setReady = false;
                this.buttonEnabled.setDelivered = false;
            }
            else if( record.state == 1) { //Inprogress

            }
            else if (record.state == 2) { //Scheduled
                this.buttonEnabled.setInprogress = false;
                this.buttonEnabled.setReady = false;
                this.buttonEnabled.setDelivered = false;
            }
            else if (record.state == 3) { //Ready
                this.buttonEnabled.setReady = false;
                this.buttonEnabled.setDelivered = false;
                this.buttonEnabled.setInprogress = false;
                this.buttonEnabled.changePickupTime = false;
                this.buttonEnabled.changePickupDate = false;
                this.buttonEnabled.setAsap = false;
            }
            else if (record.state == 4) { //Unmanaged

            }
            else if (record.state == 5) { //delivered
                this.buttonEnabled.setReady = false;
                this.buttonEnabled.setDelivered = false;
                this.buttonEnabled.changePickupTime = false;
                this.buttonEnabled.changePickupDate = false;
                this.buttonEnabled.setAsap = false;
                this.buttonEnabled.setInprogress = false;
            }
            else {
                this.buttonEnabled.setReady = false;
                this.buttonEnabled.setDelivered = false;
                this.buttonEnabled.changePickupTime = false;
                this.buttonEnabled.changePickupDate = false;
                this.buttonEnabled.setAsap = false;
                this.buttonEnabled.setInprogress = false;
            }
        },  


        handleCancel() {
            this.reset();
        },

        handleReady() {
            this.$emit('setReadyEventClicked');
            console.log('handleReady:')
            this.reset();
            

        },

        handlePendingToInprogress() {
            this.$emit('setInprogressEventClicked');
            console.log('handlePendingToInprogress')
            this.reset();
        },

        handleDelivered() {

            this.$emit('setDeliveredEventClicked');
            this.reset();
            
        },

        handleViewOrder() {
            console.log('handleView:')
            this.$emit('viewOrderEventClicked');
            this.reset();
        },

        handlePrint() {
            this.$emit('setPrintOrderEventClicked');
            this.reset();
            
        },

        handleChangePriorityOrASAP() {
            this.$emit('setChangedPriorityOrASAPClicked');
            this.reset();
        },

        handlePayment() {
            //this.$emit('makePaymentEventClicked');
            this.reset();
            
        },

        handleChangePickupTime() {
            this.$emit('changePickupTimeEventClicked');
            this.reset();
        },

        handleChangePickupDate() {
            this.$emit('changePickupDateEventClicked');
            this.reset();
        },

        handleCancelOrder() {
            this.$emit('cancelOrderEventClicked');
            this.reset();
        },

        reset() {
            console.log('reset is called')
            this.isVisible = false;
            this.buttonEnabled = {
                setReady : true,
                setDelivered : true,
                changePickupTime : true,
                changePickupDate : true,
                setAsap : true,
                print : true,
                cancelOrder : true,
                makePayment : true,
                setInprogress : true,
            }
        }
        
    }
}
</script>

<style scoped>
button {
    margin-top: 10px;
}
</style>